import React from 'react';
import classes from './Menu.module.css';

const menu = (props) => {
    // onClick={props.open}
    return (
        <div className={classes.MenuToggle} onClick={props.clicked}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
};

export default menu;